const types = {
  FETCH_DASHBOARD: "FETCH_DASHBOARD",
};

export default types;
